<script>
import getSecret from '@utils/get-secret'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'

export default {
  page: {
    title: 'Home',
    meta: [{ name: 'description', content: getSecret('DESCRIPTION') }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: this.$t('home'),
      items: [
        {
          text: this.$t('home'),
          active: true
        }
      ],
    }
  },
}
</script>

<template>
  <Layout>
    <div class="w-100 d-flex justify-content-center align-items-center">
      <div class="col-6 mt-4">
        <!--?xml version="1.0" encoding="UTF-8"?-->
        <svg id="svg_euro" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="100%" height="100%" viewBox="0 0 497.5 279.3" version="1.1" class="mt-5">
          <defs>
            <clipPath id="clip1">
              <path d="M 0 235 L 497 235 L 497 279.300781 L 0 279.300781 Z M 0 235 " class="svg-euro-1"></path>
            </clipPath>
            <clipPath id="clip2">
              <path d="M 1 142 L 497.5 142 L 497.5 228 L 1 228 Z M 1 142 " class="svg-euro-2"></path>
            </clipPath>
          </defs>
          <g id="surface1">
          <g clip-path="url(#clip1)" clip-rule="nonzero">
            <path style="stroke: none; fill-rule: evenodd; fill: rgb(255, 236, 0); fill-opacity: 1;" d="M 0.0507813 279.261719 L 496.347656 279.261719 L 496.347656 235.867188 L 0.0507813 235.867188 Z M 0.0507813 279.261719 " class="svg-euro-3"></path>
          </g>
          <g clip-path="url(#clip2)" clip-rule="nonzero">
            <path style="stroke: none; fill-rule: evenodd; fill: rgb(16, 42, 131); fill-opacity: 1;" d="M 84.414063 200.160156 L 113.804688 200.160156 L 113.804688 203.371094 C 113.804688 219.632813 95.925781 227.746094 60.167969 227.746094 C 35.878906 227.746094 20.007813 224.917969 12.503906 219.304688 C 5.003906 213.65625 1.253906 201.738281 1.253906 183.515625 C 1.253906 167.316406 5.179688 156.4375 13.027344 150.847656 C 20.832031 145.289063 36.140625 142.496094 58.859375 142.496094 C 80.664063 142.496094 95.273438 145.203125 102.683594 150.640625 C 110.097656 156.078125 113.804688 166.746094 113.804688 182.652344 L 113.804688 188.746094 L 31.125 188.746094 C 30.996094 190.589844 30.90625 191.808594 30.90625 192.402344 C 30.90625 200.578125 32.738281 206.042969 36.445313 208.753906 C 40.152344 211.488281 47.566406 212.855469 58.597656 212.855469 C 69.324219 212.855469 76.304688 212.046875 79.53125 210.476563 C 82.800781 208.871094 84.414063 205.417969 84.414063 200.160156 Z M 84.675781 176.558594 L 84.542969 173.261719 C 84.542969 166.632813 82.84375 162.324219 79.488281 160.359375 C 76.128906 158.371094 68.800781 157.386719 57.59375 157.386719 C 46.691406 157.386719 39.585938 158.578125 36.316406 160.953125 C 33.042969 163.328125 31.386719 168.535156 31.386719 176.558594 Z M 246.632813 143.535156 L 246.632813 226.789063 L 217.375 226.789063 L 219.03125 212.496094 L 218.507813 212.4375 C 212.839844 222.632813 199.710938 227.746094 179.171875 227.746094 C 151.480469 227.746094 137.660156 218.324219 137.660156 199.449219 L 137.660156 143.535156 L 166.917969 143.535156 L 166.917969 194.664063 C 166.917969 201.738281 168.359375 206.402344 171.28125 208.632813 C 174.15625 210.863281 180.175781 211.992188 189.289063 211.992188 C 207.996094 211.992188 217.375 204.324219 217.375 188.984375 L 217.375 143.535156 Z M 277.070313 143.535156 L 306.332031 143.535156 L 304.542969 155.21875 L 305.199219 155.308594 C 312.175781 146.597656 323.164063 142.230469 338.167969 142.230469 C 359.621094 142.230469 370.347656 151.472656 370.347656 169.933594 L 370.347656 175.757813 L 342.746094 175.757813 C 343.09375 173.496094 343.269531 172.011719 343.269531 171.300781 C 343.269531 162.410156 338.210938 157.984375 328.046875 157.984375 C 313.570313 157.984375 306.332031 164.578125 306.332031 177.746094 L 306.332031 226.789063 L 277.070313 226.789063 Z M 440.207031 142.585938 C 463.800781 142.585938 479.238281 145.140625 486.5625 150.285156 C 493.886719 155.425781 497.550781 166.277344 497.550781 182.804688 C 497.550781 201.261719 493.976563 213.390625 486.824219 219.121094 C 479.671875 224.863281 464.585938 227.746094 441.601563 227.746094 C 416.660156 227.746094 400.480469 225.070313 393.113281 219.71875 C 385.742188 214.398438 382.078125 202.628906 382.078125 184.46875 C 382.078125 166.988281 385.699219 155.632813 392.9375 150.433594 C 400.175781 145.203125 415.917969 142.585938 440.207031 142.585938 Z M 439.945313 158.339844 C 427.78125 158.339844 420.015625 159.824219 416.703125 162.828125 C 413.386719 165.828125 411.730469 172.785156 411.730469 183.785156 C 411.730469 196.328125 413.300781 204.144531 416.441406 207.292969 C 419.625 210.414063 427.472656 211.992188 440.078125 211.992188 C 452.242188 211.992188 459.917969 210.328125 463.101563 207.027344 C 466.285156 203.730469 467.898438 195.761719 467.898438 183.160156 C 467.898438 172.546875 466.242188 165.742188 462.925781 162.769531 C 459.613281 159.824219 451.9375 158.339844 439.945313 158.339844 Z M 439.945313 158.339844 " class="svg-euro-4"></path>
          </g>
            <path style="stroke: none; fill-rule: evenodd; fill: rgb(16, 42, 131); fill-opacity: 1;" d="M 9.726563 262.261719 L 18.300781 261.746094 C 18.484375 263.078125 18.863281 264.089844 19.433594 264.789063 C 20.355469 265.914063 21.6875 266.476563 23.410156 266.476563 C 24.695313 266.476563 25.683594 266.191406 26.382813 265.613281 C 27.074219 265.035156 27.421875 264.367188 27.421875 263.609375 C 27.421875 262.890625 27.097656 262.242188 26.429688 261.667969 C 25.765625 261.101563 24.230469 260.566406 21.816406 260.058594 C 17.867188 259.210938 15.050781 258.089844 13.367188 256.683594 C 11.667969 255.277344 10.820313 253.488281 10.820313 251.308594 C 10.820313 249.878906 11.253906 248.523438 12.125 247.253906 C 12.992188 245.980469 14.296875 244.984375 16.039063 244.253906 C 17.785156 243.527344 20.171875 243.164063 23.207031 243.164063 C 26.933594 243.164063 29.777344 243.824219 31.734375 245.144531 C 33.6875 246.46875 34.847656 248.574219 35.222656 251.457031 L 26.730469 251.929688 C 26.507813 250.679688 26.03125 249.765625 25.304688 249.195313 C 24.585938 248.632813 23.585938 248.347656 22.316406 248.347656 C 21.265625 248.347656 20.476563 248.554688 19.949219 248.984375 C 19.417969 249.402344 19.15625 249.917969 19.15625 250.53125 C 19.15625 250.972656 19.371094 251.367188 19.808594 251.722656 C 20.234375 252.09375 21.238281 252.429688 22.832031 252.746094 C 26.769531 253.558594 29.585938 254.382813 31.289063 255.210938 C 32.996094 256.039063 34.238281 257.066406 35.011719 258.292969 C 35.785156 259.519531 36.175781 260.894531 36.175781 262.414063 C 36.175781 264.199219 35.65625 265.847656 34.625 267.351563 C 33.589844 268.859375 32.148438 270 30.285156 270.777344 C 28.433594 271.554688 26.09375 271.945313 23.269531 271.945313 C 18.3125 271.945313 14.878906 271.039063 12.972656 269.210938 C 11.058594 267.386719 9.980469 265.074219 9.726563 262.261719 Z M 68.769531 243.636719 L 77.765625 243.636719 L 77.765625 260.234375 C 77.765625 261.878906 77.492188 263.429688 76.957031 264.894531 C 76.421875 266.351563 75.578125 267.636719 74.433594 268.730469 C 73.285156 269.824219 72.082031 270.585938 70.820313 271.039063 C 69.070313 271.652344 66.972656 271.960938 64.515625 271.960938 C 63.097656 271.960938 61.550781 271.875 59.875 271.679688 C 58.195313 271.492188 56.796875 271.117188 55.671875 270.550781 C 54.546875 269.988281 53.511719 269.183594 52.578125 268.148438 C 51.640625 267.109375 51.003906 266.039063 50.65625 264.9375 C 50.097656 263.164063 49.820313 261.601563 49.820313 260.234375 L 49.820313 243.636719 L 58.8125 243.636719 L 58.8125 260.628906 C 58.8125 262.152344 59.257813 263.339844 60.132813 264.1875 C 61.015625 265.039063 62.234375 265.46875 63.804688 265.46875 C 65.351563 265.46875 66.574219 265.046875 67.453125 264.207031 C 68.332031 263.371094 68.769531 262.167969 68.769531 260.628906 Z M 92.785156 243.636719 L 107.757813 243.636719 C 111.015625 243.636719 113.460938 244.371094 115.082031 245.859375 C 116.703125 247.335938 117.519531 249.449219 117.519531 252.179688 C 117.519531 254.992188 116.636719 257.1875 114.863281 258.769531 C 113.09375 260.351563 110.390625 261.140625 106.761719 261.140625 L 101.832031 261.140625 L 101.832031 271.472656 L 92.785156 271.472656 Z M 101.832031 255.503906 L 104.039063 255.503906 C 105.777344 255.503906 106.992188 255.21875 107.695313 254.640625 C 108.398438 254.0625 108.75 253.324219 108.75 252.429688 C 108.75 251.554688 108.445313 250.808594 107.832031 250.207031 C 107.230469 249.597656 106.082031 249.289063 104.398438 249.289063 L 101.832031 249.289063 Z M 131.3125 243.636719 L 155.449219 243.636719 L 155.449219 249.578125 L 140.339844 249.578125 L 140.339844 254.007813 L 154.355469 254.007813 L 154.355469 259.683594 L 140.339844 259.683594 L 140.339844 265.164063 L 155.886719 265.164063 L 155.886719 271.472656 L 131.3125 271.472656 Z M 169.953125 271.472656 L 169.953125 243.636719 L 184.964844 243.636719 C 187.75 243.636719 189.878906 243.863281 191.34375 244.324219 C 192.820313 244.777344 194.007813 245.621094 194.910156 246.855469 C 195.8125 248.089844 196.257813 249.59375 196.257813 251.359375 C 196.257813 252.910156 195.914063 254.238281 195.230469 255.359375 C 194.535156 256.480469 193.585938 257.390625 192.382813 258.089844 C 191.609375 258.527344 190.558594 258.898438 189.222656 259.183594 C 190.292969 259.527344 191.074219 259.871094 191.570313 260.214844 C 191.894531 260.441406 192.378906 260.921875 193.007813 261.667969 C 193.640625 262.421875 194.0625 262.996094 194.269531 263.402344 L 198.628906 271.472656 L 188.449219 271.472656 L 183.636719 262.960938 C 183.023438 261.867188 182.480469 261.148438 182 260.816406 C 181.355469 260.390625 180.617188 260.171875 179.792969 260.171875 L 179 260.171875 L 179 271.472656 Z M 179 254.914063 L 182.800781 254.914063 C 183.207031 254.914063 184.003906 254.789063 185.183594 254.539063 C 185.78125 254.417969 186.269531 254.128906 186.648438 253.660156 C 187.023438 253.195313 187.210938 252.65625 187.210938 252.042969 C 187.210938 251.148438 186.914063 250.460938 186.316406 249.980469 C 185.71875 249.496094 184.601563 249.253906 182.957031 249.253906 L 179 249.253906 Z M 210.507813 243.636719 L 222.359375 243.636719 L 226.933594 260.570313 L 231.488281 243.636719 L 243.296875 243.636719 L 243.296875 271.472656 L 235.941406 271.472656 L 235.941406 250.246094 L 230.230469 271.472656 L 223.574219 271.472656 L 217.886719 250.246094 L 217.886719 271.472656 L 210.507813 271.472656 Z M 258.121094 243.636719 L 282.257813 243.636719 L 282.257813 249.578125 L 267.148438 249.578125 L 267.148438 254.007813 L 281.164063 254.007813 L 281.164063 259.683594 L 267.148438 259.683594 L 267.148438 265.164063 L 282.699219 265.164063 L 282.699219 271.472656 L 258.121094 271.472656 Z M 296.761719 271.472656 L 296.761719 243.636719 L 311.777344 243.636719 C 314.558594 243.636719 316.691406 243.863281 318.15625 244.324219 C 319.628906 244.777344 320.816406 245.621094 321.71875 246.855469 C 322.621094 248.089844 323.070313 249.59375 323.070313 251.359375 C 323.070313 252.910156 322.726563 254.238281 322.039063 255.359375 C 321.347656 256.480469 320.394531 257.390625 319.195313 258.089844 C 318.421875 258.527344 317.371094 258.898438 316.03125 259.183594 C 317.105469 259.527344 317.886719 259.871094 318.378906 260.214844 C 318.707031 260.441406 319.1875 260.921875 319.820313 261.667969 C 320.449219 262.421875 320.871094 262.996094 321.082031 263.402344 L 325.441406 271.472656 L 315.257813 271.472656 L 310.445313 262.960938 C 309.835938 261.867188 309.292969 261.148438 308.808594 260.816406 C 308.164063 260.390625 307.425781 260.171875 306.605469 260.171875 L 305.8125 260.171875 L 305.8125 271.472656 Z M 305.8125 254.914063 L 309.613281 254.914063 C 310.019531 254.914063 310.8125 254.789063 311.992188 254.539063 C 312.589844 254.417969 313.078125 254.128906 313.460938 253.660156 C 313.832031 253.195313 314.023438 252.65625 314.023438 252.042969 C 314.023438 251.148438 313.726563 250.460938 313.128906 249.980469 C 312.53125 249.496094 311.410156 249.253906 309.769531 249.253906 L 305.8125 249.253906 Z M 356.09375 260.097656 L 363.988281 262.378906 C 363.457031 264.492188 362.621094 266.253906 361.480469 267.671875 C 360.339844 269.09375 358.921875 270.164063 357.234375 270.882813 C 355.542969 271.609375 353.390625 271.960938 350.785156 271.960938 C 347.613281 271.960938 345.023438 271.523438 343.019531 270.648438 C 341.011719 269.765625 339.273438 268.21875 337.8125 266.003906 C 336.363281 263.785156 335.628906 260.953125 335.628906 257.496094 C 335.628906 252.890625 336.910156 249.34375 339.476563 246.871094 C 342.042969 244.402344 345.671875 243.164063 350.363281 243.164063 C 354.035156 243.164063 356.921875 243.867188 359.023438 245.289063 C 361.128906 246.707031 362.691406 248.886719 363.707031 251.820313 L 355.753906 253.511719 C 355.476563 252.664063 355.183594 252.039063 354.878906 251.648438 C 354.375 250.992188 353.757813 250.488281 353.03125 250.128906 C 352.296875 249.773438 351.484375 249.597656 350.582031 249.597656 C 348.542969 249.597656 346.976563 250.382813 345.890625 251.953125 C 345.070313 253.117188 344.65625 254.945313 344.65625 257.441406 C 344.65625 260.53125 345.152344 262.644531 346.128906 263.789063 C 347.113281 264.9375 348.492188 265.507813 350.261719 265.507813 C 351.984375 265.507813 353.289063 265.046875 354.171875 264.121094 C 355.054688 263.203125 355.691406 261.859375 356.09375 260.097656 Z M 395.390625 266.878906 L 385.128906 266.878906 L 383.71875 271.472656 L 374.515625 271.472656 L 385.46875 243.636719 L 395.289063 243.636719 L 406.253906 271.472656 L 396.824219 271.472656 Z M 393.507813 260.855469 L 390.28125 250.847656 L 387.078125 260.855469 Z M 418.347656 243.636719 L 431.734375 243.636719 C 434.367188 243.636719 436.496094 243.980469 438.128906 244.660156 C 439.75 245.347656 441.09375 246.324219 442.152344 247.601563 C 443.210938 248.886719 443.976563 250.371094 444.460938 252.066406 C 444.933594 253.765625 445.171875 255.5625 445.171875 257.460938 C 445.171875 260.433594 444.820313 262.742188 444.105469 264.382813 C 443.402344 266.019531 442.417969 267.394531 441.152344 268.496094 C 439.898438 269.605469 438.546875 270.34375 437.101563 270.710938 C 435.125 271.21875 433.335938 271.472656 431.734375 271.472656 L 418.347656 271.472656 Z M 427.355469 249.941406 L 427.355469 265.148438 L 429.5625 265.148438 C 431.449219 265.148438 432.785156 264.953125 433.578125 264.546875 C 434.375 264.15625 435 263.453125 435.453125 262.464844 C 435.902344 261.472656 436.125 259.859375 436.125 257.628906 C 436.125 254.679688 435.621094 252.664063 434.617188 251.574219 C 433.605469 250.488281 431.9375 249.941406 429.601563 249.941406 Z M 457.867188 257.570313 C 457.867188 253.027344 459.195313 249.488281 461.84375 246.960938 C 464.496094 244.421875 468.1875 243.164063 472.917969 243.164063 C 477.773438 243.164063 481.511719 244.40625 484.140625 246.894531 C 486.757813 249.378906 488.074219 252.863281 488.074219 257.34375 C 488.074219 260.597656 487.5 263.265625 486.351563 265.347656 C 485.207031 267.421875 483.550781 269.042969 481.382813 270.207031 C 479.210938 271.367188 476.519531 271.945313 473.28125 271.945313 C 469.996094 271.945313 467.273438 271.445313 465.113281 270.449219 C 462.964844 269.441406 461.21875 267.863281 459.875 265.695313 C 458.539063 263.53125 457.867188 260.824219 457.867188 257.570313 Z M 466.878906 257.609375 C 466.878906 260.417969 467.421875 262.4375 468.515625 263.664063 C 469.609375 264.894531 471.101563 265.507813 472.980469 265.507813 C 474.914063 265.507813 476.414063 264.90625 477.472656 263.707031 C 478.53125 262.503906 479.070313 260.34375 479.070313 257.234375 C 479.070313 254.609375 478.511719 252.695313 477.40625 251.484375 C 476.300781 250.277344 474.800781 249.671875 472.898438 249.671875 C 471.085938 249.671875 469.628906 250.285156 468.527344 251.515625 C 467.429688 252.742188 466.878906 254.777344 466.878906 257.609375 Z M 466.878906 257.609375 " class="svg-euro-5"></path>
            <path style="stroke: none; fill-rule: evenodd; fill: rgb(255, 236, 0); fill-opacity: 1;" d="M 91.03125 88.628906 L 109.417969 92.570313 L 118.789063 76.269531 L 120.71875 94.972656 L 139.117188 98.847656 L 121.925781 106.464844 L 123.925781 125.160156 L 111.371094 111.164063 L 94.207031 118.84375 L 103.640625 102.578125 Z M 91.03125 88.628906 " class="svg-euro-star1"></path>
            <path style="stroke: none; fill-rule: evenodd; fill: rgb(255, 236, 0); fill-opacity: 1;" d="M 155.609375 24.644531 L 169.328125 37.046875 L 185.328125 27.769531 L 177.773438 44.648438 L 191.542969 56.996094 L 173.152344 55.03125 L 165.660156 71.941406 L 161.851563 53.84375 L 143.453125 51.945313 L 159.488281 42.726563 Z M 155.609375 24.644531 " class="svg-euro-star2"></path>
            <path style="stroke: none; fill-rule: evenodd; fill: rgb(255, 236, 0); fill-opacity: 1;" d="M 244.410156 -0.0585938 L 250.058594 17.445313 L 268.453125 17.410156 L 253.550781 28.191406 L 259.269531 45.675781 L 244.410156 34.835938 L 229.550781 45.675781 L 235.265625 28.191406 L 220.367188 17.410156 L 238.757813 17.445313 Z M 244.410156 -0.0585938 " class="svg-euro-star3"></path>
            <path style="stroke: none; fill-rule: evenodd; fill: rgb(255, 236, 0); fill-opacity: 1;" d="M 333.210938 24.648438 L 329.328125 42.730469 L 345.363281 51.945313 L 326.964844 53.84375 L 323.15625 71.941406 L 315.667969 55.03125 L 297.277344 56.996094 L 311.042969 44.652344 L 303.488281 27.769531 L 319.488281 37.050781 Z M 333.210938 24.648438 " class="svg-euro-star4"></path>
            <path style="stroke: none; fill-rule: evenodd; fill: rgb(255, 236, 0); fill-opacity: 1;" d="M 397.785156 88.628906 L 385.175781 102.578125 L 394.609375 118.847656 L 377.445313 111.164063 L 364.890625 125.164063 L 366.890625 106.46875 L 349.699219 98.851563 L 368.097656 94.976563 L 370.027344 76.273438 L 379.398438 92.574219 Z M 397.785156 88.628906 " class="svg-euro-star5"></path>
          </g>
        </svg>
      </div>
    </div>
  </Layout>
</template>

<style lang="css">
/***************************************************
 * Generated by SVG Artista on 12/1/2022, 9:09:13 AM
 * MIT license (https://opensource.org/licenses/MIT)
 * W. https://svgartista.net
 **************************************************/
 @-webkit-keyframes animate-svg-fill-1 {
  0% {
    fill: transparent;
  }

  100% {
    fill: rgb(0, 0, 0);
  }
}

@keyframes animate-svg-fill-1 {
  0% {
    fill: transparent;
  }

  100% {
    fill: rgb(0, 0, 0);
  }
}

.svg-euro-1 {
  -webkit-animation: animate-svg-fill-1 1.5s cubic-bezier(0.47, 0, 0.745, 0.715) 0.5s both;
          animation: animate-svg-fill-1 1.5s cubic-bezier(0.47, 0, 0.745, 0.715) 0.5s both;
}

@-webkit-keyframes animate-svg-fill-2 {
  0% {
    fill: transparent;
  }

  100% {
    fill: rgb(0, 0, 0);
  }
}

@keyframes animate-svg-fill-2 {
  0% {
    fill: transparent;
  }

  100% {
    fill: rgb(0, 0, 0);
  }
}

.svg-euro-2 {
  -webkit-animation: animate-svg-fill-2 1.5s cubic-bezier(0.47, 0, 0.745, 0.715) 0.8s both;
          animation: animate-svg-fill-2 1.5s cubic-bezier(0.47, 0, 0.745, 0.715) 0.8s both;
}

@-webkit-keyframes animate-svg-fill-3 {
  0% {
    fill: transparent;
  }

  100% {
    fill: rgb(255, 236, 0);
  }
}

@keyframes animate-svg-fill-3 {
  0% {
    fill: transparent;
  }

  100% {
    fill: rgb(255, 236, 0);
  }
}

.svg-euro-3 {
  -webkit-animation: animate-svg-fill-3 1.5s cubic-bezier(0.47, 0, 0.745, 0.715) 1.1s both;
          animation: animate-svg-fill-3 1.5s cubic-bezier(0.47, 0, 0.745, 0.715) 1.1s both;
}

@-webkit-keyframes animate-svg-fill-4 {
  0% {
    fill: transparent;
  }

  100% {
    fill: rgb(16, 42, 131);
  }
}

@keyframes animate-svg-fill-4 {
  0% {
    fill: transparent;
  }

  100% {
    fill: rgb(16, 42, 131);
  }
}

.svg-euro-4 {
  -webkit-animation: animate-svg-fill-4 1.5s cubic-bezier(0.47, 0, 0.745, 0.715) 1.4s both;
          animation: animate-svg-fill-4 1.5s cubic-bezier(0.47, 0, 0.745, 0.715) 1.4s both;
}

@-webkit-keyframes animate-svg-fill-5 {
  0% {
    fill: transparent;
  }

  100% {
    fill: rgb(16, 42, 131);
  }
}

@keyframes animate-svg-fill-5 {
  0% {
    fill: transparent;
  }

  100% {
    fill: rgb(16, 42, 131);
  }
}

.svg-euro-5 {
  -webkit-animation: animate-svg-fill-5 1.5s cubic-bezier(0.47, 0, 0.745, 0.715) 1.7s both;
          animation: animate-svg-fill-5 1.5s cubic-bezier(0.47, 0, 0.745, 0.715) 1.7s both;
}

@-webkit-keyframes animate-svg-fill-6 {
  0% {
    fill: transparent;
  }

  100% {
    fill: rgb(255, 236, 0);
    filter: drop-shadow(0px 3px 3px rgba(0, 0, 0, 0.4));
  }
}

@keyframes animate-svg-fill-6 {
  0% {
    fill: transparent;
  }

  100% {
    fill: rgb(255, 236, 0);
    filter: drop-shadow(0px 3px 3px rgba(0, 0, 0, 0.4));
  }
}


@-webkit-keyframes animate-svg-fill-7 {
  0% {
    fill: transparent;
  }

  100% {
    fill: rgb(255, 236, 0);
    filter: drop-shadow(0px 3px 3px rgba(0, 0, 0, 0.4));
  }
}

@keyframes animate-svg-fill-7 {
  0% {
    fill: transparent;
  }

  100% {
    fill: rgb(255, 236, 0);
    filter: drop-shadow(0px 3px 3px rgba(0, 0, 0, 0.4));
  }
}



@-webkit-keyframes animate-svg-fill-8 {
  0% {
    fill: transparent;
  }

  100% {
    fill: rgb(255, 236, 0);
    filter: drop-shadow(0px 3px 3px rgba(0, 0, 0, 0.4));
  }
}

@keyframes animate-svg-fill-8 {
  0% {
    fill: transparent;
  }

  100% {
    fill: rgb(255, 236, 0);
    filter: drop-shadow(0px 3px 3px rgba(0, 0, 0, 0.4));
  }
}



@-webkit-keyframes animate-svg-fill-9 {
  0% {
    fill: transparent;
  }

  100% {
    fill: rgb(255, 236, 0);
    filter: drop-shadow(0px 3px 3px rgba(0, 0, 0, 0.4));
  }
}

@keyframes animate-svg-fill-9 {
  0% {
    fill: transparent;
  }

  100% {
    fill: rgb(255, 236, 0);
    filter: drop-shadow(0px 3px 3px rgba(0, 0, 0, 0.4));
  }
}



@-webkit-keyframes animate-svg-fill-10 {
  0% {
    fill: transparent;
  }

  100% {
    fill: rgb(255, 236, 0);
    filter: drop-shadow(0px 3px 3px rgba(0, 0, 0, 0.4));
  }
}

@keyframes animate-svg-fill-10 {
  0% {
    fill: transparent;
  }

  100% {
    fill: rgb(255, 236, 0);
    filter: drop-shadow(0px 3px 3px rgba(0, 0, 0, 0.4));
  }
}

.svg-euro-star1 {
  -webkit-animation: animate-svg-fill-10 1.5s cubic-bezier(0.47, 0, 0.745, 0.715) 2s both;
          animation: animate-svg-fill-10 1.5s cubic-bezier(0.47, 0, 0.745, 0.715) 2s both;
}

.svg-euro-star2 {
  -webkit-animation: animate-svg-fill-9 1.5s cubic-bezier(0.47, 0, 0.745, 0.715) 2.3s  both;
          animation: animate-svg-fill-9 1.5s cubic-bezier(0.47, 0, 0.745, 0.715) 2.3s  both;
}
.svg-euro-star3 {
  -webkit-animation: animate-svg-fill-6 1.5s cubic-bezier(0.47, 0, 0.745, 0.715) 2.6s both;
          animation: animate-svg-fill-6 1.5s cubic-bezier(0.47, 0, 0.745, 0.715) 2.6s both;
}
.svg-euro-star4 {
  -webkit-animation: animate-svg-fill-7 1.5s cubic-bezier(0.47, 0, 0.745, 0.715) 2.9s both;
          animation: animate-svg-fill-7 1.5s cubic-bezier(0.47, 0, 0.745, 0.715) 2.9s both;
}
.svg-euro-star5 {
  -webkit-animation: animate-svg-fill-8 1.5s cubic-bezier(0.47, 0, 0.745, 0.715) 3.2s both;
          animation: animate-svg-fill-8 1.5s cubic-bezier(0.47, 0, 0.745, 0.715) 3.2s both; 
}
</style>
